import { apiBaseUrl } from '../config/api';

export type HomepageEngagementEventName =
  | 'homepage_video_play_clicked'
  | 'homepage_signup_page_opened'
  | 'homepage_live_demo_clicked'
  | 'homepage_live_demo_started';

type HomepageEngagementMetadata = Record<string, string | number | boolean | null | undefined>;

type HomepageEngagementOptions = {
  source?: string;
  destination?: string;
  metadata?: HomepageEngagementMetadata;
};

const normalizeMetadata = (metadata: HomepageEngagementMetadata = {}) =>
  Object.fromEntries(
    Object.entries(metadata)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(([key, value]) => [key, String(value)])
  );

export const trackHomepageEngagementEvent = (
  eventName: HomepageEngagementEventName,
  options: HomepageEngagementOptions = {}
) => {
  if (typeof window === 'undefined') {
    return;
  }

  const payload = {
    eventName,
    pagePath: `${window.location.pathname}${window.location.search}${window.location.hash}`,
    source: options.source,
    destination: options.destination,
    metadata: normalizeMetadata(options.metadata),
  };

  void fetch(`${apiBaseUrl}/HomepageEngagement/Track`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    keepalive: true,
    credentials: 'omit',
  }).catch(() => undefined);
};
